import { useEffect, useState } from "react";
import { Plus, Archive } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "../lib/api";

export default function Businesses() {
  const [lookups, setLookups] = useState(null);
  const [name, setName] = useState("");
  const [projName, setProjName] = useState({});

  const load = () => api.get("/lookups").then((r) => setLookups(r.data));
  useEffect(() => { load(); }, []);

  const addBiz = async () => {
    if (!name.trim()) return toast.error("Name required");
    await api.post("/businesses", { name: name.trim() });
    setName("");
    toast.success("Business added");
    load();
  };

  const addProject = async (bid) => {
    const n = (projName[bid] || "").trim();
    if (!n) return toast.error("Project name required");
    await api.post(`/businesses/${bid}/projects`, { name: n });
    setProjName({ ...projName, [bid]: "" });
    toast.success("Project added");
    load();
  };

  const archiveBiz = async (id) => { await api.delete(`/businesses/${id}`); toast.success("Archived"); load(); };
  const archiveProj = async (id) => { await api.delete(`/projects/${id}`); toast.success("Archived"); load(); };

  const businesses = lookups?.businesses || [];
  const projects = lookups?.projects || [];

  return (
    <div className="px-5 pt-8" data-testid="businesses-page">
      <h1 className="text-2xl font-heading font-bold tracking-tight">Businesses</h1>
      <p className="mt-1 text-sm text-muted-foreground">Attribute expenses to a business or project when adding transactions.</p>

      <div className="mt-4 flex gap-2">
        <input data-testid="biz-add-name" className="flex-1 h-12 px-4 rounded-xl bg-white border border-border" placeholder="New business name" value={name} onChange={(e) => setName(e.target.value)} />
        <button data-testid="biz-add-btn" onClick={addBiz} className="h-12 w-12 rounded-xl bg-primary text-primary-foreground flex items-center justify-center"><Plus size={18} /></button>
      </div>

      <div className="mt-4 space-y-3 mb-6">
        {businesses.length === 0 && <p className="mt-6 text-sm text-muted-foreground text-center">No businesses yet.</p>}
        {businesses.map((b) => (
          <div key={b.id} className="bg-white border border-border rounded-2xl p-4">
            <div className="flex items-center gap-2">
              <span className="flex-1 font-medium">{b.name}</span>
              <button data-testid={`biz-archive-${b.id}`} onClick={() => archiveBiz(b.id)} className="h-10 w-10 flex items-center justify-center rounded-xl text-muted-foreground active:bg-secondary"><Archive size={16} /></button>
            </div>
            {projects.filter((p) => p.business_id === b.id).map((p) => (
              <div key={p.id} className="mt-2 flex items-center gap-2 pl-3 border-l-2 border-border">
                <span className="flex-1 text-sm">{p.name}</span>
                <button data-testid={`proj-archive-${p.id}`} onClick={() => archiveProj(p.id)} className="h-9 w-9 flex items-center justify-center rounded-lg text-muted-foreground active:bg-secondary"><Archive size={14} /></button>
              </div>
            ))}
            <div className="mt-3 flex gap-2">
              <input data-testid={`proj-add-name-${b.id}`} className="flex-1 h-10 px-3 rounded-xl bg-background border border-border text-sm" placeholder="Add project…" value={projName[b.id] || ""} onChange={(e) => setProjName({ ...projName, [b.id]: e.target.value })} />
              <button data-testid={`proj-add-btn-${b.id}`} onClick={() => addProject(b.id)} className="h-10 px-3 rounded-xl border border-border text-sm font-medium">Add</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
